import { render } from "./vphotoid.vue?vue&type=template&id=693275ac&scoped=true"
import script from "./vphotoid.vue?vue&type=script&lang=js"
export * from "./vphotoid.vue?vue&type=script&lang=js"

import "./vphotoid.vue?vue&type=style&index=0&id=693275ac&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693275ac"]])

export default __exports__